
import { FAIL_SOUND, SUCCESS_SOUND } from '@/utils/constants'
import { Howl } from 'howler'
import { Options, Vue } from 'vue-class-component'

interface IScanSound {
  play: Function
  once: Function
}

@Options({
  name: 'SoundMixin',
})
export default class SoundMixin extends Vue {
  successScanSound: IScanSound = new Howl({
    src: [SUCCESS_SOUND],
    onplayerror: (soundId: string, errMessage: string) => {
      this.successScanSound.once('unlock', () => this.successScanSound.play())
    },
  })

  failScanSound: IScanSound = new Howl({
    src: [FAIL_SOUND],
    onplayerror: (soundId: string, errMessage: string) => {
      this.failScanSound.once('unlock', () => this.failScanSound.play())
    },
  })

  playSuccessSound() {
    this.successScanSound.play()
  }

  playFailSound() {
    this.failScanSound.play()
  }
}
